import React from "react";
import { useStyles } from "./getintouch.styles";
import TitlePart from "../../../components/TitlePart/TitlePart";
import logo from "../../../assets/logo/normal.svg";
import gitImg from "../../../assets/svgs/GitHub.svg";
import linkedIng from "../../../assets/svgs/LinkedIn.svg";
import codingame from "../../../assets/svgs/Xing.svg";

import OutlinedButton from "../../../components/buttons/OutlinedButton/OutlinedButton";
import { ContactMe } from "../../../functions/contact_me";

function GetInTouch() {
  const styles = useStyles();

  return (
    <div className={styles.main} id="Contact">
      <span className="number">05. What’s Next?</span>
      <h1 className="big-title">Get In Touch</h1>

      <p className="desc">
        Email me at <span>farahdridy@gmail.com</span> and let's talk about your project!
      </p>

      <p className="desc">
        My inbox is always open. Whether you have a question or just want to say
        hi, I’ll try my best to get back to you!
      </p>

      <div className="divider">&nbsp;</div>

      <div align="center">
        <a href="https://mail.google.com/mail/?view=cm&to=farahdridy@gmail.com"><img src="https://raw.githubusercontent.com/maurodesouza/profile-readme-generator/master/src/assets/icons/social/gmail/default.svg" alt="gmail logo" /></a>
        <a href="https://www.linkedin.com/in/farah-dridi-it-engineer/"><img src="https://raw.githubusercontent.com/maurodesouza/profile-readme-generator/master/src/assets/icons/social/linkedin/default.svg" alt="linkedin logo" /></a>
        <a href="https://wa.me/+21699672925" target="_blank">
          <img src="https://raw.githubusercontent.com/maurodesouza/profile-readme-generator/master/src/assets/icons/social/whatsapp/default.svg" alt="whatsapp logo" />
        </a>
      </div>

      <p className="copyright">© 2025 - Designed and built by Farah DRIDI</p>
    </div>
  );
}

export default GetInTouch;
